import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import DrawerTransactions from './DrawerTransactions';
import { useParams } from 'react-router-dom';
import { RootState } from 'shared/config/store/store';
import { GreyContainer } from 'shared/ui';
import classes from './Transactions.module.scss';
import { useIntl } from 'react-intl';
import { MonthSpending } from '../components/MonthSpending';
import { GetTransactionsParams } from '../api/dto';
import { MONTH_CONFIG } from '../model/constants';

const Transactions: React.FC = () => {
  const { id } = useParams();
  const currentAccount = Number(id);
  const [open, setOpen] = useState(false);
  const { formatMessage: t } = useIntl();
  const config = useRef<GetTransactionsParams>(MONTH_CONFIG);
  // Use current month start for MonthSpending to show spending only for current month
  const currentMonthStart = moment().startOf('month').format('DD-MM-YYYY');

  const lang = useSelector((state: RootState) => state.app.language).toLowerCase();

  useEffect(() => {
    moment.locale(lang);
  }, [lang]);

  return (
    <>
      <GreyContainer
        id="transactions-container"
        title={t({ id: 'transactions.title' })}
        onClick={() => setOpen(true)}
        className={classes['transactions-block']}>
        <MonthSpending accountId={currentAccount} start={currentMonthStart} />
      </GreyContainer>
      <DrawerTransactions
        open={open}
        onClose={() => setOpen(false)}
        accountId={currentAccount}
      />
    </>
  );
};

export default Transactions;
